import React, { PropsWithChildren } from 'react';

import Button, { type ButtonProps } from '.';

export type ToggleButtonProps = PropsWithChildren<{
    isActive: boolean;
}> &
    Omit<ButtonProps, 'priority'>;

export default function ToggleButton({
    children,
    isActive,
    ...props
}: ToggleButtonProps): JSX.Element {
    return (
        <Button aria-pressed={isActive} {...props} priority="secondary">
            {children}
        </Button>
    );
}
